<template>
  <div>
    <div
      class="bemor-id-name"
      :class="{ kasallikT: $route.name == 'ArxivOne' }"
    >
      <!-- Patient ID Select -->
      <div
        class="bemor-id-div mobil-disebled"
        :class="{ pointerEvents: $route.name == 'Update' }"
      >
        <label>Пациент ID</label>
        <v-select
          class="select-id-bemor"
          :options="items"
          @input="selectChange"
          @search="onSearch"
          :filterable="false"
          label="id"
          v-model="selectedBemor"
          :reduce="options => options.id"
          placeholder="ID..."
        >
          <template #option="{ id, fullname }">
            <b>{{ id }}</b> - {{ fullname }}
          </template>
        </v-select>
      </div>

      <!-- Bemor Name Select -->
      <div class="bemor-name-div">
        <label>
          {{ $t("Бемор") }}
          <span style="color: red;">*</span>
        </label>
        <div
          style="display: flex;"
          :class="{ pointerEvents: $route.name == 'Update' }"
        >
          <div style="width: 370px;">
            <v-select
              class="selektBemor"
              :options="items"
              @input="selectChange"
              @search="onSearch"
              :filterable="false"
              label="fullname"
              v-model="selectedBemor"
              :reduce="options => options.id"
              :placeholder="$t('Қидириш...')"
              :loading="loading"
            >
              <template #no-options="{ search, searching }">
                <template v-if="searching">
                  "<b>{{ search }}</b>" bo'yicha hech narsa topilmadi.
                </template>
                <em v-else>Ism yoki familiya yozing...</em>
              </template>
              <template #option="{ fullname, id }">
                {{ fullname }}
                <br />
                <b>ID: {{ id }}</b>
              </template>
            </v-select>
          </div>
          <div>
            <b-button
              v-b-modal.modal-bemorqidiruv
              variant="primary"
              class="bemor-modal-btn"
            >
              ...
            </b-button>
          </div>

          <!-- Modal Search Table -->
          <b-modal
            id="modal-bemorqidiruv"
            size="xl"
            title="Бемор қидириш"
            hide-footer
          >
            <div class="mb-2 modalQidiruv">
              <div class="qidiruv-btn">
                <b-input-group size="sm">
                  <b-input
                    id="filter-input"
                    v-model="filter"
                    type="search"
                    @input="onModalSearch"
                    :placeholder="$t('Қидирув (Ism, Tel yoki Passport)...')"
                  ></b-input>
                  <b-input-group-append>
                    <b-button
                      :disabled="!filter"
                      variant="danger"
                      @click="filter = ''; getPatient()"
                    >{{ $t("Тозалаш") }}</b-button>
                  </b-input-group-append>
                </b-input-group>
              </div>
            </div>
            
            <div>
              <b-table
                id="bemor-table"
                ref="refBemorTable"
                hover
                striped
                primary-key="id"
                :items="items"
                :fields="fields"
                @row-clicked="selectChange"
                stacked="md"
                show-empty
                small
                :busy="loading"
              >
                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Yuklanmoqda...</strong>
                  </div>
                </template>
                
                <template #cell(№)="data">
                  {{ (currentPage - 1) * perPage + data.index + 1 }}
                </template>
              </b-table>

              <!-- Pagination Controls -->
              <div class="mt-3">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  align="center"
                  @change="handlePageChange"
                ></b-pagination>
              </div>
            </div>
          </b-modal>
        </div>
      </div>

      <!-- Static Info Panels -->
      <div class="mobil-disebled">
        <label>{{ $t("Рўйхатга олувчи") }}</label>
        <div class="sum-u operator">{{ user_name }}</div>
      </div>
      <div class="mobil-disebled">
        <label>{{ $t("Келган вақти") }}</label>
        <div class="sum-u date">{{ kelgan_kun | dateFormatDD }}</div>
      </div>
      <div class="mobil-disebled" v-if="localUser.role != 'Loborant' && localUser.role != 'Shifokor'">
        <label>{{ $t("Умумий сумма") }}</label>
        <div class="sum-u summa">{{ summa | numFormat }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import _ from "lodash"; // Debounce uchun lodash kerak

export default {
  props: ["newBemor", "summa", "kelgan_kun", "user_name"],
  data() {
    return {
      selectedBemor: this.$store.state.bemor.id,
      localUser: JSON.parse(localStorage.getItem("user")),
      items: [],
      fields: [
        "№",
        { key: "id", label: "ID" },
        { key: "fullname", label: "Ф.И.Ш", sortable: false },
        { key: "district.name", label: "Тумани", sortable: false },
        { key: "addres", label: "Уй Манзили", sortable: false }
      ],
      totalRows: 0,
      currentPage: 1,
      perPage: 20,
      filter: "",
      loading: false
    };
  },
  filters: {
    dateFormatDD: function(date) {
      if (date != null) {
        return moment.unix(date).format("DD.MM.YYYY HH:mm:ss");
      }
      return "";
    }
  },
  methods: {
    // Asosiy ma'lumotlarni serverdan olish (Pagination va Search bilan)
    async getPatient(search = "", page = 1) {
      this.loading = true;
      try {
        const response = await axios.get("/patient/all", {
          params: {
            page: page,
            limit: this.perPage,
            search: search
          }
        });
        
        this.items = response.data.data;
        this.totalRows = response.data.pagination.totalItems;
        this.currentPage = response.data.pagination.currentPage;
      } catch (error) {
        console.error("Bemorlarni yuklashda xatolik:", error);
      } finally {
        this.loading = false;
      }
    },

    // v-select ichida qidirish (Server-side)
    onSearch(search, loading) {
      if (search.length < 2) return;
      loading(true);
      this.debouncedGetPatient(search, loading);
    },

    // Serverga so'rovni kechiktirib yuborish (Debounce)
    debouncedGetPatient: _.debounce(async function(search, loading) {
      await this.getPatient(search, 1);
      if (loading) loading(false);
    }, 500),

    // Modal ichidagi qidiruv inputi uchun
    onModalSearch: _.debounce(function() {
      this.getPatient(this.filter, 1);
    }, 500),

    // Sahifa o'zgarganda (Pagination)
    handlePageChange(page) {
      this.getPatient(this.filter, page);
    },

    // Tanlash funksiyasi
    selectChange(e) {
      if (!e) {
        this.$emit("bemorChange", null);
        return;
      }

      let selectedObj = null;
      if (typeof e === "object") {
        selectedObj = e;
      } else {
        selectedObj = this.items.find(val => val.id == e);
      }

      if (selectedObj) {
        this.selectedBemor = selectedObj.id;
        this.$emit("bemorChange", selectedObj);
        this.$bvModal.hide("modal-bemorqidiruv");
      }
    }
  },
  mounted() {
    this.getPatient();
  },
  watch: {
    newBemor(newVal) {
      if (newVal) {
        // Yangi bemor qo'shilsa ro'yxatni yangilash
        this.getPatient();
        this.selectedBemor = newVal.id;
      }
    }
  }
};
</script>

<style scoped>
.pointerEvents {
  pointer-events: none;
}
.selektBemor .vs__selected-options span:first-child {
  width: 90% !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
.bemor-id-name {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  border: 1px solid #007bff;
  width: 100%;
  border-radius: 10px;
  background: #f0f0f0;
}
.modalQidiruv {
  width: 100%;
  display: flex;
  justify-content: end;
}
.qidiruv-btn {
  width: 40% !important;
}
.bemor-id-name label {
  font-size: 16px;
  font-weight: 600;
  color: #007bff;
}
.bemor-id-div {
  width: 150px;
}
.bemor-name-div {
  width: 400px;
}
.sum-u {
  border-radius: 5px;
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  background: #fff;
  border: 1px solid #ccc;
  color: red;
  height: 35px;
}
.summa { width: 140px; }
.date { width: 190px; font-size: 16px; }
.operator {
  width: 300px;
  font-size: 14px;
  justify-content: start;
  padding-left: 10px;
  font-weight: 400;
  color: black;
}
</style>